module.exports = __webpack_public_path__ + "img/ico-modification-request.922f3981.svg";